var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.5 1.5H24V0H6V1.5H1.5C0.6 1.5 0 2.1 0 3V6.6C0 10.05 2.55 12.9 6 13.35V13.5C6 17.85 9 21.45 13.05 22.35L12 25.5H8.55C7.95 25.5 7.35 25.95 7.2 26.55L6 30H24L22.8 26.55C22.65 25.95 22.05 25.5 21.45 25.5H18L16.95 22.35C21 21.45 24 17.85 24 13.5V13.35C27.45 12.9 30 10.05 30 6.6V3C30 2.1 29.4 1.5 28.5 1.5ZM6 10.35C4.35 9.9 3 8.4 3 6.6V4.5H6V10.35ZM18 15L15 13.35L12 15L12.75 12L10.5 9H13.65L15 6L16.35 9H19.5L17.25 12L18 15ZM27 6.6C27 8.4 25.65 10.05 24 10.35V4.5H27V6.6Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconTrophy);
export default __webpack_public_path__ + "static/media/trusted-icon-trophy.9b29282bb1fdc0d4bb8501e08bd298fa.svg";
export { ForwardRef as ReactComponent };